import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Card, Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


export default function BookingPlotDetails() {
  const { customerId } = useParams() // Get the customerId from the URL
  const [bookings, setBookings] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCustomerBookings = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const response = await axios.get(BASE_URL+
          `/customer/bookings?id=${customerId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        setBookings(response.data.data) // Assuming response has booking data in `data.data`
        setLoading(false)
      } catch (error) {
        toast.error('Failed to fetch booking details.')
        setLoading(false)
      }
    }

    fetchCustomerBookings()
  }, [customerId])

  if (loading) {
    return <p>Loading booking details...</p>
  }
  return (
    <Container className="pb-3" style={{fontFamily: theme.font.family }}>

<div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>
        
          <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
            
Customer's Bookings            
            
            </p>
          <Table
            bordered
            hover
            responsive="md"
            className="text-center  table  table-bordered table-hover"
          >
            <thead className="position-sticky top-0  text-start ">
<tr className="text-start ">
  {/* <th>Customer ID</th> */}
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Number</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Name</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Actual Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Block</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Status</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Is Corner</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Size</th>
</tr>

            </thead>
            <tbody>
              {Array.isArray(bookings) && bookings.length > 0 ? (
                bookings.map((booking) => (
                  <tr className="text-start" key={booking.id}>
                    <td>{booking.plot_details[0].plot_number}</td>
                    <td>{booking.plot_details[0].name}</td>
                    <td>₹ {booking.plot_details[0].price}</td>
                    <td>{booking.plot_details[0].block}</td>
                    <td>{booking.booking_status}</td>
                    <td>
                      {booking.plot_details[0].is_corner ? 'Yes' : 'NULL'}
                    </td>
                    <td>{booking.plot_details[0].plot_size} sq. ft.</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={11}>No bookings found for this customer.</td>
                </tr>
              )}
            </tbody>
          </Table>
          </div>
    </Container>
  )
}
